export default __webpack_public_path__ + "static/media/panel-item-closed.9afc99af.svg";